export default __webpack_public_path__ + "static/media/bdswissDemo_downloadMT4.b84b1adc.png";